import { useState } from "react";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import logo from "../../Assets/Logo/lipana.png";



const MobileNav = ({ navData, accounts, hideNavBar, active, products }) => {

  const [showProducts, setShowProducts] = useState(false);
  return (
    <div
      className={`absolute ${
        active ? `top-0` : `top-[-1500%]`
      } left-0 w-full h-screen overflow-auto z-50 bg-[#010F24] text-white space-y-6 px-6 flex flex-col py-3 lg:hidden`}
    >
      <div className="flex flex-row items-center justify-between mb-5 mt-6">
        <Link to="/" className="flex flex-row items-center z-50 lg:ml-0">
          <img src={logo} alt="logos" className="h-8 w-full object-contain" />
        </Link>
        <CloseIcon className="!text-4xl" onClick={() => hideNavBar()} />
      </div>
      <div className="flex flex-col space-y-8 text-xl">
        {navData.map((link, i) =>
          link.name.toLowerCase() === "products" ? (
            <div key={i}>
              <div>
                <p
                  onClick={() => setShowProducts(!showProducts)}
                  className="font-semibold flex flex-row justify-between"
                >
                  {link.name}
                  {showProducts ? (
                    <KeyboardArrowUpIcon className="!text-3xl" />
                  ) : (
                    <KeyboardArrowDownIcon className="!text-3xl" />
                  )}
                </p>
                <div
                  className={`${
                    showProducts ? `block` : `hidden`
                  } duration-1000 space-y-5 mt-3`}
                >
                  {products.map((product, i) => (
                    <div key={i} className="space-y-5">
                    <h2 className="font-semibold text-lg">{product.name}</h2>
                    {product.items.map((item, i) => (
                      <Link to="/pricing" className="flex flex-row items-center gap-3" key={i}>
                        <div className="bg-[#DCE6F6] text-brandColor h-[30px] w-[30px] flex flex-row items-center justify-center rounded-lg">
                          {<item.icon className ="!text-2xl"/>}
                        </div>
                        <div className="space-y-1">
                          <h2 className="text-base font-semibold">{item.name}</h2>
                          <p className="text-gray-600 text-sm">{item.text}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <Link
              onClick={() => hideNavBar()}
              to={link.name === "Home" ? `/` : `/${link.name.toLowerCase()}`}
              key={i}
              className={`font-semibold ${
                link.type === "btn" ? `py-1 px-5 rounded-full` : ""
              } hover:text-brandColor duration-500 cursor-pointer`}
            >
              {`${link.name === "Sign In" ? link.name : link.name}`}
            </Link>
          )
        )}
      </div>

      <div className="flex flex-col items-center !mt-16">
        {accounts.map((link, i) => (
          <a
            onClick={() => hideNavBar()}
            href="http://app.lipana.co.ke/signup"
            key={i}
            className={`font-semibold md:hidden ${
              link.type === "btn"
                ? `bg-[#0567FB] py-3 z-50 px-5 rounded-full text-white text-center w-full md:w-max hover:opacity-[0.8] duration-500`
                : ` hidden`
            }`}
          >
            {link.name}
          </a>
        ))}
      </div>
    </div>
  );
};

export default MobileNav;
